import { Link as LinkIcon } from '@otp/icons';
import { ActionsColumn, useNotifications } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import {
  ResourcePageItem,
  SearchResultDto,
  SearchType,
} from 'src/graphql/generated/graphql';

export const LinkColumn = ({ item }: { item: Partial<SearchResultDto> }) => {
  const notifications = useNotifications();
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common.search',
  });
  const icon = <LinkIcon />;

  let onClick: () => void;

  switch (item.type) {
    case SearchType.Resource:
      onClick = () => {
        const resource = JSON.parse(item.data as string);
        const url =
          resource?.items[0]?.item?.currentFileVersion?.fileAsset?.url;

        if (url) {
          window.open(url, '_blank');
        } else {
          notifications.show(t('list.link-expired'), {
            severity: 'warning',
          });
        }
      };
      break;
    default:
      onClick = () => {
        notifications.show(t('list.link-not-available'), {
          severity: 'warning',
        });
      };
  }

  return (
    <ActionsColumn
      icons={[
        {
          icon: icon,
          onClick: onClick,
        },
      ]}
    />
  );
};
